/**
 * Baixar um arquivo de mídia — de verdade.
 *
 * O atributo `download` de um `<a>` é **ignorado quando a URL é de outra
 * origem**. Nossos arquivos ficam no S3, que é outra origem, então
 * `<a href={s3Url} download>` não baixa nada: o navegador simplesmente navega
 * até o arquivo. Com `target="_blank"` junto, abre numa aba nova — que é
 * exatamente o que se via no lightbox, no Lucas e no Inbox.
 *
 * `fetch` + blob também não serve: o S3 direto bloqueia por CORS.
 *
 * O que funciona é passar pela nossa API, que redireciona para uma URL
 * assinada com `Content-Disposition: attachment`. Aí o download acontece
 * mesmo sendo outra origem, porque quem manda baixar é o servidor.
 *
 * Este helper existe porque a mesma chamada estava copiada em quatro lugares e
 * o quinto — o lightbox — tinha feito diferente, e errado.
 */

/**
 * @param {string} url — endereço do arquivo no S3
 * @param {string} [filename] — nome com que ele deve chegar ao disco
 */
export function downloadMedia(url, filename) {
  if (!url) return;

  const params = new URLSearchParams({ url });
  if (filename) params.set("filename", filename);

  const link = document.createElement("a");
  link.href = `/api/inbox/media/download-url?${params}`;
  // A autenticação é por cookie HttpOnly, então a navegação carrega a sessão
  // sozinha — não dá para usar `fetch` com header aqui sem perder o download.
  link.click();
}

export default downloadMedia;
